import { useEffect, useState } from "react";

export default function useKakaoLoader() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // 이미 초기화되어 있다면
    if (window.Kakao && window.Kakao.isInitialized()) {
      setIsLoaded(true);
      return;
    }

    // 이미 로드되어 있지만 초기화되지 않았다면 초기화
    if (window.Kakao) {
      try {
        if (!window.Kakao.isInitialized()) {
          window.Kakao.init("1c6c3d0206749465e0bcfcf58b020237");
        }
        setIsLoaded(true);
        return;
      } catch (error) {
        console.error("카카오 SDK 초기화 실패:", error);
      }
    }

    // 스크립트가 이미 존재하는지 확인
    const existingScript = document.querySelector('script[src*="kakao"]');
    if (existingScript) {
      // 스크립트가 로드 중이면 완료를 기다림
      const checkInterval = setInterval(() => {
        if (window.Kakao) {
          try {
            if (!window.Kakao.isInitialized()) {
              window.Kakao.init("1c6c3d0206749465e0bcfcf58b020237");
            }
            setIsLoaded(true);
            clearInterval(checkInterval);
          } catch (error) {
            console.error("카카오 SDK 초기화 실패:", error);
          }
        }
      }, 100);

      // 5초 후 타임아웃
      setTimeout(() => {
        clearInterval(checkInterval);
      }, 5000);

      return () => clearInterval(checkInterval);
    }

    // 새 스크립트 태그 생성
    const script = document.createElement("script");
    script.src = "https://developers.kakao.com/sdk/js/kakao.js";
    script.async = true;

    // 로드 완료 후 초기화
    script.onload = () => {
      try {
        if (window.Kakao && !window.Kakao.isInitialized()) {
          window.Kakao.init("1c6c3d0206749465e0bcfcf58b020237");
        }
        setIsLoaded(true);
      } catch (error) {
        console.error("카카오 SDK 초기화 실패:", error);
      }
    };

    // 에러 처리
    script.onerror = () => {
      console.error("카카오 SDK 로드 실패");
      setIsLoaded(false);
    };

    // HTML에 추가
    document.head.appendChild(script);
  }, []);

  return isLoaded;
}
